'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _EntypoIcon = require('../EntypoIcon');

var _EntypoIcon2 = _interopRequireDefault(_EntypoIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var iconClass = 'entypo-svgicon entypo--Untag';

var EntypoUntag = function EntypoUntag(props) {
    return _react2.default.createElement(
        _EntypoIcon2.default,
        _extends({ propClass: iconClass }, props),
        _react2.default.createElement('path', { d: 'M1,14.742l4.945-0.709L5.239,19l5.962-5.985L7.132,8.586L1,14.742z M18.664,5.521c0.391-0.393,0.5-0.945,0-1.419l-2.826-2.839c-0.279-0.308-1.021-0.392-1.412,0l-3.766,3.78l4.068,4.429L18.664,5.521z M18.706,15.293l-14.001-14c-0.391-0.391-1.023-0.391-1.414,0c-0.391,0.391-0.391,1.023,0,1.414l14.001,14C17.488,16.903,17.744,17,17.999,17c0.256,0,0.512-0.098,0.707-0.293C19.097,16.317,19.097,15.684,18.706,15.293z' })
    );
};

exports.default = EntypoUntag;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-entypo-icons/lib/entypo/Untag.js
// module id = 7570
// module chunks = 0